import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-step-policy-info',
  templateUrl: './step-policy-info.component.html',
  styleUrls: ['./step-policy-info.component.css']
})
export class StepPolicyInfoComponent {
  @Input() form!: FormGroup;
}
